/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Form_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Video Filters" |
*
* @param {Video_Filters_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_form_aria_label = /** @type {((inputs?: Video_Filters_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtres video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videofilter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtri video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеофильтры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtros de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频滤镜")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオフィルター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो फ़िल्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtros de vídeo")
	return /** @type {LocalizedString} */ ("Video Filters")
});